import "swiper/swiper-bundle.min.css"
import { initializeExperiments } from "./src/hooks/experiments"
import wrapPageElement from "./src/wrapPageElement"
import wrapRootElement from "./src/wrapRootElement"

import {
  trackSegmentPageEvent,
  triggerSegmentIntegration,
} from "@utils/analytics"

const onClientEntry = () => {
  initializeExperiments()

  if (window) {
    window.initConvertIntegration = function () {
      triggerSegmentIntegration()
    }
  }
}

const onRouteUpdate = ({ location, prevLocation }) => {
  trackSegmentPageEvent(location.pathname, location.href)
  window.prevUrl = prevLocation ? prevLocation.pathname : undefined
}

export { wrapRootElement, wrapPageElement, onRouteUpdate, onClientEntry }
